/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreBank131DisableRecurrentPaymentRequest interface.
 */
export function instanceOfFxIdApplicationStoreBank131DisableRecurrentPaymentRequest(value) {
    if (!('PublicId' in value) || value['PublicId'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreBank131DisableRecurrentPaymentRequestFromJSON(json) {
    return FxIdApplicationStoreBank131DisableRecurrentPaymentRequestFromJSONTyped(json, false);
}
export function FxIdApplicationStoreBank131DisableRecurrentPaymentRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'PublicId': json['PublicId'],
    };
}
export function FxIdApplicationStoreBank131DisableRecurrentPaymentRequestToJSON(json) {
    return FxIdApplicationStoreBank131DisableRecurrentPaymentRequestToJSONTyped(json, false);
}
export function FxIdApplicationStoreBank131DisableRecurrentPaymentRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'PublicId': value['PublicId'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreBank131DisableRecurrentPaymentRequest.js.map